//#region src/KitOrders/types.ts
var KitOrderTestType = /* @__PURE__ */ function(KitOrderTestType) {
	KitOrderTestType["HEREDITARY_30"] = "hereditary 30";
	KitOrderTestType["HEREDITARY_25"] = "hereditary 25";
	KitOrderTestType["HEREDITARY_41"] = "hereditary 41";
	KitOrderTestType["BREAST_OVARIAN_19"] = "breast ovarian 19";
	KitOrderTestType["WISDOM_9"] = "wisdom 9";
	KitOrderTestType["FH_5"] = "fh 5";
	KitOrderTestType["FH_3"] = "fh 3";
	KitOrderTestType["CARDIO_30"] = "cardio 30";
	KitOrderTestType["WES"] = "whole exome";
	KitOrderTestType["WGS"] = "whole genome";
	KitOrderTestType["LCWGS"] = "low coverage whole genome";
	KitOrderTestType["BRCA_1_2"] = "brca 1 2";
	KitOrderTestType["HEREDITARY_7"] = "hereditary 7";
	KitOrderTestType["PGX_V1"] = "pgx v1";
	KitOrderTestType["PGX_V3"] = "pgx v3";
	KitOrderTestType["PMS_2"] = "pms2";
	KitOrderTestType["ACMG_59"] = "acmg 59";
	KitOrderTestType["HDR_59"] = "hdr 59";
	KitOrderTestType["METABOLISM_4"] = "metabolism 4";
	KitOrderTestType["COVID_19"] = "covid-19";
	KitOrderTestType["COVID_19_ANTIGEN"] = "covid-19 antigen";
	KitOrderTestType["ESSENTIAL_CARE_KIT"] = "preventive health kit";
	KitOrderTestType["AOU_HDR_V1"] = "aou acmg 59";
	KitOrderTestType["AOU_PGX_V1"] = "aou pgx v1";
	KitOrderTestType["CHLAMYDIA_ANAL"] = "chlamydia trachomatis - anal";
	KitOrderTestType["CHLAMYDIA_ORAL"] = "chlamydia trachomatis - oral";
	KitOrderTestType["CHLAMYDIA_URINE"] = "chlamydia trachomatis - urine";
	KitOrderTestType["GONORRHEA_ANAL"] = "neisseria gonorrhoeae - anal";
	KitOrderTestType["GONORRHEA_ORAL"] = "neisseria gonorrhoeae - oral";
	KitOrderTestType["GONORRHEA_URINE"] = "neisseria gonorrhoeae - urine";
	return KitOrderTestType;
}({});
var KitOrderStatus = /* @__PURE__ */ function(KitOrderStatus) {
	KitOrderStatus["NO_ORDER"] = "no_order";
	KitOrderStatus["ONSITE_PURCHASE"] = "onsite_purchase";
	KitOrderStatus["NOT_SHIPPED"] = "not_shipped";
	KitOrderStatus["SHIPPED_TO_HOME"] = "shipped_to_home";
	KitOrderStatus["SHIPPED_TO_HOME_FAILED"] = "shipped_to_home_failed";
	KitOrderStatus["DELIVERED_TO_HOME"] = "delivered_to_home";
	KitOrderStatus["DELIVERED_TO_HOME_ACTIVATED"] = "delivered_to_home_activated";
	KitOrderStatus["COLLECTED_ONSITE_ACTIVATED"] = "collected_onsite_activated";
	KitOrderStatus["SHIPPED_TO_LAB"] = "shipped_to_lab";
	KitOrderStatus["USPS_LOST_PACKAGE"] = "usps_lost_package";
	KitOrderStatus["USPS_LOST_PACKAGE_NEW_KIT_SHIPPED"] = "usps_lost_package_new_kit_shipped";
	KitOrderStatus["AT_LAB_SEQUENCING"] = "at_lab_sequencing";
	KitOrderStatus["AT_LAB_SEQUENCING_KNOWN_DELAY"] = "at_lab_sequencing_known_delay";
	KitOrderStatus["AT_LAB_SEQUENCING_UNKNOWN_DELAY"] = "at_lab_sequencing_unknown_delay";
	KitOrderStatus["AT_LAB_NOT_ACTIVATED"] = "at_lab_not_activated";
	KitOrderStatus["AT_LAB_DATA_REUSE"] = "at_lab_data_reuse";
	KitOrderStatus["PENDING_EXTERNAL_PHYSICIAN"] = "pending_external_physician";
	KitOrderStatus["PENDING_GC_SESSION"] = "pending_gc_session";
	KitOrderStatus["RELEASED_NOT_OPENED"] = "released_not_opened";
	KitOrderStatus["RELEASED_AND_OPENED"] = "released_opened";
	KitOrderStatus["RERELEASED_NOT_OPENED"] = "rereleased_not_opened";
	KitOrderStatus["RERELEASED_AND_OPENED"] = "rereleased_opened";
	KitOrderStatus["WISDOM_ORDER"] = "wisdom_order";
	KitOrderStatus["CANCELED_ORDER"] = "canceled";
	return KitOrderStatus;
}({});
var CANCER_TEST_TYPES = [
	"hereditary 30",
	"hereditary 25",
	"hereditary 41",
	"breast ovarian 19",
	"wisdom 9",
	"brca 1 2",
	"hereditary 7",
	"pms2"
];
var GENETIC_TEST_TYPES = [
	...CANCER_TEST_TYPES,
	"fh 5",
	"fh 3",
	"cardio 30",
	"whole exome",
	"whole genome",
	"low coverage whole genome",
	"pgx v1",
	"pgx v3",
	"metabolism 4",
	"acmg 59",
	"hdr 59",
	"aou acmg 59",
	"aou pgx v1"
];
var COVID_TEST_TYPES = ["covid-19", "covid-19 antigen"];
var ESSENTIAL_CARE_TEST_TYPES = ["preventive health kit"];
var STI_TEST_TYPES = [
	"chlamydia trachomatis - anal",
	"chlamydia trachomatis - oral",
	"chlamydia trachomatis - urine",
	"neisseria gonorrhoeae - anal",
	"neisseria gonorrhoeae - oral",
	"neisseria gonorrhoeae - urine"
];
//#endregion
//#region src/KitOrders/utils.ts
var ACRONYMS = [
	"MRI",
	"CT",
	"XRAY",
	"US",
	"DX",
	"PSA",
	"HPV",
	"FIT",
	"IO",
	"LCB",
	"MTL",
	"USSL",
	"PREP",
	"PGX",
	"BRCA",
	"HDR",
	"FH",
	"STI",
	"MR",
	"CAD",
	"GI",
	"LDL",
	"HDL"
];
var PROPER_NAMES = {
	HBA1C: "HbA1c",
	SKINIO: "SkinIO",
	WITH: "with",
	"W/O": "w/o",
	"AND/OR": "and/or"
};
var formatPanelWord = (word) => {
	const upperCaseWord = word.toUpperCase();
	if (PROPER_NAMES[upperCaseWord]) return PROPER_NAMES[upperCaseWord];
	if (ACRONYMS.findIndex((term) => upperCaseWord.replace(/\W/g, "") === term) !== -1) return upperCaseWord;
	if (ACRONYMS.includes(upperCaseWord)) return upperCaseWord;
	return upperCaseWord.charAt(0).toUpperCase() + upperCaseWord.slice(1).toLowerCase();
};
var formatPanelTypeOrTestName = (value) => {
	return value.replace(/_/g, " ").split(" ").filter(Boolean).map(formatPanelWord).join(" ");
};
//#endregion
export { GENETIC_TEST_TYPES as a, STI_TEST_TYPES as c, ESSENTIAL_CARE_TEST_TYPES as i, CANCER_TEST_TYPES as n, KitOrderStatus as o, COVID_TEST_TYPES as r, KitOrderTestType as s, formatPanelTypeOrTestName as t };

//# sourceMappingURL=KitOrders-BOjeD1SH.js.map